export default [
    {
        name: 'cadastro-loteamento',
        path: 'loteamento',
        redirect: 'loteamento/index',
        component: () => import(/* webpackChunkName: 'cadastro-loteamento' */ '@/views/cadastro/loteamento/Index'),
        children: [
            {
                meta: { title: 'Lista de loteamentos' },
                name: 'cadastro-loteamento-index',
                path: 'index',
                component: () => import(/* webpackChunkName: 'cadastro-loteamento' */ '@/views/cadastro/loteamento/List.vue'),
            },
            {
                meta: { title: 'Cadastro de loteamento' },
                name: 'cadastro-loteamento-create',
                path: 'create',
                component: () => import(/* webpackChunkName: 'cadastro-loteamento' */ '@/views/cadastro/loteamento/Form.vue'),
            },
            {
                meta: { title: 'Edição de loteamento' },
                name: 'cadastro-loteamento-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(/* webpackChunkName: 'cadastro-loteamento' */ '@/views/cadastro/loteamento/Form.vue'),
            },
        ],
    },
]